import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/i18n/LangContext";
import LandingPage from "@/pages/LandingPage";
import ConstructionPage from "@/pages/ConstructionPage";
import TravauxPage from "@/pages/TravauxPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/construction" element={<ConstructionPage />} />
          <Route path="/travaux" element={<TravauxPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
